import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PersonSelectorService } from "../../../../personselector/personselector.service";
import { DataService_ReminderAlertSetup } from "../../shared/data.service";
import { LoadPersonRequest } from "../../shared/LoadPersonRequest";
import { PersonLoadInfo } from "../../shared/PersonLoadInfo";
import { StationReminderAlertPersonInsertRequest } from "../../shared/StationReminderAlertPersonInsertRequest";

@Component({
	selector: "app-add-scan-reminder-person",
	templateUrl: "./add-scan-reminder-person.component.html",
	styleUrls: ["./add-scan-reminder-person.component.css"],
})
export class AddScanReminderPersonComponent implements OnInit {
	constructor(
		private personService: PersonSelectorService,
		private ReminderAlertPersonService: DataService_ReminderAlertSetup,
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.StationReminderAlertID = this.dialogConfig.data.StationReminderAlertID;
		this.Message = this.dialogConfig.data.Message;
		this.MessageFontColor = this.dialogConfig.data.MessageFontColor;

		this.PersonSubscription = this.personService.onSelectedMultiplePersons().subscribe((lstPersonIDs) => {
			this.onAddToGroup(lstPersonIDs);
		});
	}

	ngOnDestroy() {
		this.PersonSubscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	StationReminderAlertID: number;
	Message: string = "";
	MessageFontColor: string = "";

	PersonSubscription: any;

	lstPersonToAdd: PersonLoadInfo[] = []; //Students from selector
	lstPerson: any = []; //Loaded data
	loading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	SelectStudentExpand: boolean = true;
	StudentsToAddExpand: boolean = true;

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadPersonInfo() {
		this.errorMessage = "";

		//Get list of students that haven't been loaded
		var lstToLoad: number[] = [];

		//Start from end and take non-loaded entries that were added recently
		for (var z = this.lstPersonToAdd.length - 1; z >= 0; z--) {
			var next = this.lstPersonToAdd[z];

			if (next.Loaded == false) {
				lstToLoad = [...lstToLoad, next.PersonID];
				next.Loaded = true;
			} else {
				break; //Hit end of non-loaded entries (New ones get added to end of list)
			}
		}

		if (lstToLoad.length == 0) {
			return;
		}

		this.loading = true;

		let parms: LoadPersonRequest = {
			lstPersonIDs: lstToLoad,
		};

		//
		// Call WS
		//

		var result = this.ReminderAlertPersonService.AssignPersonSelectList(parms);
		result.subscribe(
			(response: any) => {
				for (var z = 0; z < response.length; z++) {
					var next = response[z];

					var found = false;
					for (var x = 0; x < this.lstPerson.length; x++) {
						var nextPerson = this.lstPerson[x];

						if (next.PersonID == nextPerson.PersonID) {
							found = true;
							break;
						}
					}

					if (!found) {
						this.lstPerson = [...this.lstPerson, next];
					}
				}

				this.StudentsToAddExpand = true;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onAdd() {
		var lstPIDs: number[] = [];

		for (var z = 0; z < this.lstPerson.length; z++) {
			var next = this.lstPerson[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		if (lstPIDs.length == 0) {
			this.errorMessage = "Select students from the selector to assign the reminder to";
			this.SelectStudentExpand = true;
			return;
		}

		this.Processing = true;

		let parms: StationReminderAlertPersonInsertRequest = {
			StationReminderAlertID: this.StationReminderAlertID,
			lstPersonIDs: lstPIDs,
		};

		var result = this.ReminderAlertPersonService.StationReminderAlertPersonInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Reminder was assigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign reminder to the students",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////
	onAddToGroup(lstPersonIDs: number[]) {
		this.errorMessage = "";

		//
		// Go through Person IDs
		//
		for (var z = 0; z < lstPersonIDs.length; z++) {
			var nextID = lstPersonIDs[z];

			// If it's not already in the list, add it
			var found = false;
			for (var x = 0; x < this.lstPersonToAdd.length; x++) {
				var nextPersonInfo = this.lstPersonToAdd[x];

				if (nextID == nextPersonInfo.PersonID) {
					found = true;
				}
			}

			if (!found) {
				var newInfo: PersonLoadInfo = {
					PersonID: nextID,
					Loaded: false, //Not loaded yet
				};

				this.lstPersonToAdd = [...this.lstPersonToAdd, newInfo];
			}
		}

		this.loadPersonInfo();
	}

	onRemoveAll() {
		this.errorMessage = "";

		this.lstPerson = [];
		this.lstPersonToAdd = [];
	}

	onRemovePerson(Person) {
		this.errorMessage = "";

		this.lstPerson = this.lstPerson.filter((p) => p.PersonID != Person.PersonID);
		this.lstPersonToAdd = this.lstPersonToAdd.filter((p) => p.PersonID != Person.PersonID);
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
